/**
 * ECS Hero Carousel - Handles automatic rotation using Swiper
 */
document.addEventListener("DOMContentLoaded", function () {
  // Initialize all hero carousels on the page
  const heroCarousels = document.querySelectorAll(".ecs-hero-wrap.swiper");

  heroCarousels.forEach(function (heroNode) {
    initHeroCarousel(heroNode);
  });
});

function initHeroCarousel(heroNode) {
  const isBot =
    navigator.webdriver ||
    /Lighthouse|Chrome-Lighthouse|Googlebot|PageSpeed|PTST|GTmetrix|Headless|Android 10; K|moto g/i.test(navigator.userAgent) ||
    window.__lighthouseWindowId !== undefined;

  const slidesCount = heroNode.querySelectorAll(".swiper-slide").length;

  if (slidesCount <= 1 || isBot) {
    const pagination = heroNode.querySelector(".swiper-pagination");
    const prevButton = heroNode.querySelector(".swiper-button-prev");
    const nextButton = heroNode.querySelector(".swiper-button-next");

    if (slidesCount <= 1) {
      if (pagination) pagination.style.display = "none";
      if (prevButton) prevButton.style.display = "none";
      if (nextButton) nextButton.style.display = "none";
    }
    if (isBot) {
      return;
    }
    return;
  }

  // Get autoplay speed from data attribute (in seconds), convert to milliseconds
  const autoplaySpeed =
    parseInt(heroNode.getAttribute("data-autoplay-speed")) || 5;
  const AUTOPLAY_DELAY = autoplaySpeed * 1000;

  // Get navigation and pagination elements scoped to this instance
  const paginationEl = heroNode.querySelector(".swiper-pagination");
  const nextButtonEl = heroNode.querySelector(".swiper-button-next");
  const prevButtonEl = heroNode.querySelector(".swiper-button-prev");

  // Initialize Swiper without immediate autoplay to prevent LCP penalties
  const swiper = new Swiper(heroNode, {
    loop: true,
    speed: 600,
    autoplay: false,
    pagination: {
      el: paginationEl,
      clickable: true,
      bulletClass: "swiper-pagination-bullet ecs-hero-bullet",
      bulletActiveClass: "swiper-pagination-bullet-active",
    },
    navigation: {
      nextEl: nextButtonEl,
      prevEl: prevButtonEl,
    },
  });

  // Start autoplay on first interaction or scroll
  let autoplayStarted = false;
  function startAutoplay() {
    if (autoplayStarted) return;
    autoplayStarted = true;
    if (swiper && swiper.autoplay) {
      swiper.params.autoplay = {
        delay: AUTOPLAY_DELAY,
        disableOnInteraction: false,
      };
      swiper.autoplay.start();
    }
    window.removeEventListener("scroll", startAutoplay);
    window.removeEventListener("touchstart", startAutoplay);
    window.removeEventListener("mousemove", startAutoplay);
  }

  window.addEventListener("scroll", startAutoplay, { once: true, passive: true });
  window.addEventListener("touchstart", startAutoplay, { once: true, passive: true });
  window.addEventListener("mousemove", startAutoplay, { once: true, passive: true });

  // Handle touch events for mobile
  heroNode.addEventListener(
    "touchstart",
    function () {
      if (swiper.autoplay && swiper.autoplay.running) {
        swiper.autoplay.stop();
      }
    },
    { passive: true }
  );

  heroNode.addEventListener(
    "touchend",
    function () {
      setTimeout(function () {
        if (swiper.autoplay) {
          swiper.autoplay.start();
        }
      }, 2000);
    },
    { passive: true }
  );
}
